import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

let host = window.location.host.replace("www.", "");
let templeteIndex = parseInt(Math.random()*3+ 1)

if(host == 'yukekj.cn'){
  templeteIndex =  1
}
else if(host == 'yunzhengxx.cn'){
  templeteIndex =  3
}
else if(host == 'chenxixx.cn'){
  templeteIndex =  2
} else if (host == 'yyqkj.top') {
  templeteIndex =  1
}
export default createStore({
  state: {
    companyName:'',
    record_num:'',
    email: '',
    templateIndex:templeteIndex,
    menuIndex:0,
    icon:`https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logo/logo_${'0'+(host == 'yyqkj.top' ? 1 : parseInt(Math.random()*8+1))}%402x.png`
  },
  getters: {
  },
  mutations: {
    setCompany(state, payload) {
      state.companyName = "昆明蓓宽乐科技有限公司";
      state.record_num = "滇ICP备2025070339号";
      state.email = "kmblekj020@126.com";
      state.address = "中国(云南)自由贸易试验区昆明片区官渡区矣六街道办事处商海路云南数字文旅产业园1080号";
      state.intro = payload.intro;
      state.title = payload.title
    },
    setMenuIndex(state, payload){
      state.menuIndex = payload
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({storage:window.sessionStorage})]
})
